import { ReactContextCapabilityToken } from './ReactContextCapability';
export {
	ReactContextCapability,
	ReactContextCapabilityMetadata,
} from './ReactContextCapability';

export const ReactCapability = {
	contextProvider: ReactContextCapabilityToken,
};
